// removed by extract-text-webpack-plugin
module.exports = {"btn":"I0MBsjpzvCZ1P_hjraaMg"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SubmitBtn/SubmitBtn.scss
 ** module id = 1041
 ** module chunks = 0
 **/